import Controller from '@ember/controller';

export default class DashboardUrlBacklinksController extends Controller {
  get url() {
    return this.model;
  }
}
